import React from 'react';
import { formatDuration } from '../../src/js/lib/duration';
import { formatNumber } from '../../src/js/lib/number';
import TippyWrapper from '../TippyWrapper';
import EffortTooltip from './EffortTooltip';
import ProfilePicture from '../Athletes/ProfilePicture';
import ContestantName from './ContestantName';

const Contestant = ({ contestant, segments, userId, index }) => {
  return (
    <tr
      key={contestant.id}
      className={`${contestant.user_id === userId ? 'current-user' : ''}`}
    >
      <td className=''>
        {contestant.filtered
          ? contestant.points > 0
            ? `${index + 1}.`
            : '-'
          : contestant?.position && contestant.position > 0
          ? `${contestant.position}.`
          : '-'}
      </td>
      <td className='flex items-center'>
        <ProfilePicture {...contestant.user} />
        <ContestantName contestant={contestant} userId={userId} />
      </td>
      {segments.map((segment, j) => {
        const effort = contestant.contest_segment_efforts.find(
          (cse) => cse.segment_id === segment.id
        );
        const pos = effort?.position;

        return (
          <td key={`${contestant.id}-${segment.id}`} className=''>
            {effort ? (
              <TippyWrapper
                content={
                  <EffortTooltip
                    effort={effort}
                    userName={contestant.user.name}
                  />
                }
                placement='right'
                useMobileFallback={true}
              >
                <span className='cursor-pointer p-2'>
                  {pos ? `#${pos}` : '-'}
                  {effort && effort.duration ? (
                    <>
                      <span className='small-body-text text-text-grey-600'>
                        {' '}
                        - {formatDuration(effort.duration)}
                      </span>
                    </>
                  ) : null}
                </span>
              </TippyWrapper>
            ) : (
              <span className='p-2'>{pos ? `#${pos}` : '-'}</span>
            )}
          </td>
        );
      })}
      <td className=''>{formatNumber(contestant.points)}pts</td>
    </tr>
  );
};

export default Contestant;
